import { Box, Button, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import vizualization from '../../../assets/02.webp';

const SignInButton = () => (
  <Button 
    href="/login" 
    variant="outlined" 
    color="primary" 
    sx={{ borderRadius: 20, mt: 2 }}
  >
    Sign in/Register
  </Button>
);


export const Demo = () => {
    return (
        <Container id="demo" style={{ scrollMarginTop: 80 }}>
            <Grid container>
                <Grid xs={12} md={4}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                        }}
                    >
                        <Box
                            component="img"
                            src={vizualization}
                            alt="logo"
                            loading="lazy"
                            sx={{
                                width: { xs: 0, sm: "360px" },
                                height: { xs: 0, sm: "360px" },
                                display: { xs: "none", sm: "block" }
                            }}
                        />
                    </Box>
                </Grid>
                <Grid xs={12} md={8}>
                    <Typography
                        component="h2"
                        variant="h2"
                        align="center"
                        color="text.primary"
                        gutterBottom
                        sx={{ marginBottom: 5, fontWeight: 400 }}
                        
                    >
                        Demo
                    </Typography>
                    <Typography
                        sx={{

                            textAlign: "center",
                            fontWeight: "200",
                            fontSize: {
                                xs: "18px",
                                md: "28px",
                            },
                            lineHeight: "32px",
                            mb: 4,
                        }}
                    >
                            Explore the live demo to see the core features in action. For a full overview of all features and to test everything yourself, please register for an account — registration is quick and lets you try the sample project on your own.
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            height: "20vh"
                        }}
                    >
                        <Grid container direction="column" alignItems="center" justifyContent="center">
                            <Button
                                variant="outlined"
                                style={{
                                    borderRadius: 35,
                                    marginTop: 10,
                                    width: 280,
                                    height: 60,
                                    marginRight: 2,
                                    background: "#fca311",
                                    color: "#65372a",
                                    borderWidth: 0
                                }}
                                component="a"
                                href="/p/gtzT2Ij4hyb0IMWB8FnL"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Typography>Open SAMPLE project 🧙‍♂️</Typography>
                            </Button>
                            <SignInButton />
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};